export const lightTheme = {
    background: '#F6F7FB',
    backgroundSecond: '#ffffff',
    navBarBackground: '#ffffff',
    wapperBackground: '#EDEDED87',
    text: '#262931',
    textSecondary: '#7b8595',
    brightness: 'brightness(0.6)',
    hoverFilter: 'brightness(0.95)',
    activeFilter: 'brightness(0.9)',
    scrollBarColor: '#d0cfcf',
    scrollBarHoverColor: '#bab8b8',
    primary: '#ab94ff',
    boxShadow: '#b6a1ec'
  }
  
  export const darkTheme = {
    background: '#262931',
    backgroundSecond: '#2F353F',
    navBarBackground: '#1a202c',
    wapperBackground: '#444d5b80',
    text: '#f5f5f5',
    textSecondary: '#7b8595',
    brightness: 'brightness(1)',
    hoverFilter: 'brightness(1.1)',
    activeFilter: 'brightness(1.3)',
    scrollBarColor: '#4d4e54',
    scrollBarHoverColor: '#636469',
    primary: '#9c85ef',
    boxShadow: '#e1d5ff'
  }